/* export class OnboardingModel implements OnboardingModelProps {
  registrationPage: OnboardingRegistrationModel;
  businessConfigPage: OnboardingBusinessModel;
  inboxxConfigPage: OnboardingInboxxConfigModel;
  storeConfigPage: OnboardingStoreConfigModel;
  multiuserConfigPage: OnboardingMultiuserConfigModel;
  constructor() {}
}

export interface OnboardingModelProps {
  registrationPage: OnboardingRegistrationModel;
  businessConfigPage: OnboardingBusinessModel;
  inboxxConfigPage: OnboardingInboxxConfigModel;
  storeConfigPage: OnboardingStoreConfigModel;
  multiuserConfigPage: OnboardingMultiuserConfigModel;
} */

export interface OnboardingModuleComponentBaseProps<T> {
  completed: boolean;
  fields: T;
}
